module.exports = __webpack_public_path__ + "img/1570924610.9b72fe90.jpg";